import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-jsonschema-form';
import { getStaticPlansSchema } from './Schema';
import { staticPlansUiSchema } from './uiSchema';
import { processForm } from '../../util/jsonSchemaUtils';
import '../DealerEditor/DealerEditor.scss';

export default class ProtectionPlansStatic extends PureComponent {
  constructor(props) {
    super(props);
    const staticPlansSchema = getStaticPlansSchema(this.props.dealer);
    const initialState = processForm(
      staticPlansSchema,
      staticPlansUiSchema,
      staticPlansSchema,
      staticPlansUiSchema,
      this.props.dealer,
    );
    this.state = {
      ...initialState,
    };
  }

  componentDidUpdate(prevProps) {
    const { dealer } = this.props;
    if (dealer !== prevProps.dealer) {
      const staticPlansSchema = getStaticPlansSchema(this.props.dealer);
      const newState = processForm(
        staticPlansSchema,
        staticPlansUiSchema,
        staticPlansSchema,
        staticPlansUiSchema,
        this.props.dealer,
      );
      this.setState(newState);

      // Reset verification state
      this.props.actions.fniVerificationReset();
    }
  }

  onSubmit = ({ formData }) => {
    const updatedDealer = {
      ...this.state.formData,
      ...formData,
    };
    this.props.onSave({
      updatedDealer,
    });
  };

  submitForm = () => {
    this.form.submit();
  };

  render() {
    return (
      <div>
        <div>
          <div className="dealer-editor-container pen-dealer-editor-container">
            <Form
              schema={getStaticPlansSchema(this.props.dealer)}
              uiSchema={staticPlansUiSchema}
              formData={this.state.formData}
              transformErrors={this.transformErrors}
              validate={this.validate}
              onSubmit={this.onSubmit}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              enctype="multipart/form-data"
              ref={form => {
                this.form = form;
              }}
            >
              <button className="hidden" />
            </Form>

            {this.state.schema.title === 'Integrations' &&
              this.renderVerificationSection()}
          </div>
        </div>
        <div className="button-container">
          <button
            className="btn btn-primary"
            onClick={() => {
              this.props.history.push(`/dealer/${this.props.dealer.id}`);
            }}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              this.submitForm();
            }}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}

ProtectionPlansStatic.propTypes = {
  onSave: PropTypes.func,
  actions: PropTypes.object,
  dealer: PropTypes.object,
  history: PropTypes.object,
};
